import React, { useEffect, useMemo, useState, useTransition } from "react";
import useNavigationUrlFactory from "@src/hooks/useNavigationUrlFactory";
import { StyledLink } from "@src/lib/rolling-start-navigation";
import { useSelectedStore } from "@src/store/reducers/CartSlice/selectors";
import { useTranslation } from "@src/hooks/useTranslation";
import NavigationMenu from "design-system/src/Navigation/NavigationMenu/NavigationMenu";
import runAfterLcp from "@src/utils/runAfterLcp";

const StoreMenu = () => {
  const store = useSelectedStore();
  const routes = useNavigationUrlFactory();
  const { t } = useTranslation(["Navigation"]);
  const [, startTransition] = useTransition();
  const [showStoreName, setShowStoreName] = useState(false);

  const storyLink = useMemo(() => {
    return routes.stores() || "";
  }, [routes]);

  // Garde le label générique au premier rendu (identique au SSR, bon pour le SEO).
  // HYDRATION-FIX : on attend la fin de l'hydratation (runAfterLcp) avant de
  // basculer sur le nom du magasin — un update trop tôt casse l'hydratation
  // des autres Suspense boundaries du Header (LoginButton, MyCartMenu…).
  useEffect(() => {
    if (!store) return;
    return runAfterLcp(
      () => {
        startTransition(() => {
          setShowStoreName(true);
        });
      },
      { timeout: 3000, fallbackDelay: 1500 }
    );
  }, [store, startTransition]);

  const label =
    showStoreName && store ? `${store.name}` : t("Tous nos shops", "Navigation");

  return (
    <StyledLink to={storyLink}>
      <NavigationMenu icon="store" label={label} />
    </StyledLink>
  );
};

export default StoreMenu;
